/**
// Usage example
// const className = classNames(
//   "base-class",
//   condition && "conditional-class",
//   { "object-class": true, "another-class": false }
// )
// console.log(className) // "base-class conditional-class object-class"

// This utility function allows you to combine multiple class names conditionally.
// It handles strings, objects, and arrays, making it versatile for various use cases.
// You can use it to create dynamic class names based on conditions, making your code cleaner and more maintainable.
//
// It also ensures that only truthy values are included in the final class name string.
// This is particularly useful in React components where you want to conditionally apply styles based on props or state.
//
// The function returns a single string containing all the class names, which can be directly used in your JSX elements.
*/
export const classNames = (
  ...classes: (string | undefined | null | boolean | Record<string, boolean>)[]
) => {
  return classes
    .flatMap(cls => {
      if (typeof cls === "object" && cls !== null && !Array.isArray(cls)) {
        return Object.entries(cls)
          .filter(([_, value]) => Boolean(value))
          .map(([key]) => key)
      }
      return cls
    })
    .filter(Boolean)
    .join(" ")
}
